import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ArrowRight } from "lucide-react";
const courses = [{
  id: "ELE-01",
  title: "Técnico Electricista",
  level: "[PROFESIONAL]",
  desc: "Formación integral en instalaciones eléctricas residenciales e industriales con certificación técnica.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/curso_electricista.png",
  link: "/ElectricalTechnicianPage"
}, {
  id: "SOL-02",
  title: "Energía Solar",
  level: "[ESPECIALIZADO]",
  desc: "Capacitación avanzada en diseño, montaje y mantenimiento de sistemas fotovoltaicos sustentables.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/curso_energia_solar.png",
  link: "/AcademicOfferPage"
}, {
  id: "AIR-03",
  title: "Aire Acondicionado",
  level: "[TÉCNICO]",
  desc: "Mantenimiento y reparación de equipos de climatización split y centrales para uso comercial.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/curso_aire_acondicionado.png",
  link: "/AirConditionerTechnicianPage"
}, {
  id: "ADM-04",
  title: "Auxiliar Contable",
  level: "[ADMINISTRATIVO]",
  desc: "Gestión contable, liquidación de haberes y herramientas administrativas para el mundo laboral.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/curso_contable.png",
  link: "/AccountingAssistantPage"
}, {
  id: "BAR-05",
  title: "Barbería Profesional",
  level: "[ESTÉTICA]",
  desc: "Técnicas modernas de corte, diseño de barba y gestión de negocios en el rubro de la barbería.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/curso_barberia.png",
  link: "/BarbershopPage"
}, {
  id: "KIN-06",
  title: "Kinesiología Deportiva",
  level: "[SALUD]",
  desc: "Especialización en rehabilitación física, prevención de lesiones y alto rendimiento atlético.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/curso_kinesiologia.png",
  link: "/SportsKinesiologyPage"
}];
export default function CourseCatalog() {
  return <section data-section-id="51201" id="cursos-relacionados" className="bg-background pt-[120px] pb-24 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl font-extrabold tracking-tight text-foreground mb-4 font-sans">
            Cursos Relacionados
          </h2>
          <p className="text-muted-foreground text-lg">
            Continúa tu formación profesional con nuestros programas especializados de alta demanda laboral.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course, i) => <Card key={course.id} data-index={i} className="group relative flex flex-col overflow-hidden rounded-[24px] border border-white/10 bg-[hsl(222,47%,15%,0.7)] backdrop-blur-md text-white transition-all duration-300 hover:shadow-2xl">
              <div className="w-full border-b border-white/10">
                <AspectRatio ratio={16 / 9}>
                  <img src={course.img} alt={course.title} className="h-full w-full object-cover brightness-90 contrast-110 hue-rotate-[190deg] transition-transform duration-500 group-hover:scale-105" />
                </AspectRatio>
              </div>

              <CardHeader className="space-y-2 pt-6">
                <div className="font-mono text-xs font-medium tracking-wider text-secondary group-hover:animate-pulse">
                  {course.level}
                </div>
                <h3 className="font-sans text-xl font-extrabold text-white">
                  {course.title}
                </h3>
              </CardHeader>

              <CardContent>
                <p className="text-sm text-slate-300 leading-relaxed">
                  {course.desc}
                </p>
              </CardContent>

              <CardFooter className="mt-auto pt-4 pb-6">
                <Button asChild className="w-full rounded-none bg-transparent hover:bg-white/5 text-secondary font-mono font-medium tracking-wide group/btn">
                  <Link to="https://wa.me/59896344395">
                    VER CURSO <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-[5px] text-secondary" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}